// Traduções em Português Brasileiro para SimpleCRM
export const ptBRMessages = {
  // Mensagens básicas do React Admin
  ra: {
    // Navegação
    navigation: {
      no_results: "Nenhum resultado encontrado.",
      no_filtered_results: "Nenhum resultado encontrado com os filtros atuais.",
      clear_filters: "Limpar filtros",
      page_error: "Erro na página",
      page_not_found: "Página não encontrada",
      page_rows_per_page: "Linhas por página:",
        page_range_info: "%{offsetBegin}-%{offsetEnd} de %{total}",
      },
      notification: {
        updated: "Elemento atualizado",
        created: "Elemento criado", 
        deleted: "Elemento excluído",
        item_does_not_exist: "Elemento não existe",
        http_error: "Erro HTTP",
        bad_item: "Elemento inválido",
        canceled: "Cancelado",
        logged_out: "Sessão expirada, por favor reconecte",
        not_authorized: "Você não tem permissão para acessar este recurso",
        not_found: "Página não encontrada",
        server_error: "Erro do servidor",
        unprocessable_entity: "Erro de validação",
        unsupported_media_type: "Tipo de mídia não suportado",
        // Mensagens específicas do React Admin
        "Element updated": "Elemento atualizado",
        "Element created": "Elemento criado",
        "Element deleted": "Elemento excluído",
        "Element does not exist": "Elemento não existe",
        "Bad item": "Elemento inválido",
        "HTTP Error": "Erro HTTP",
        "Canceled": "Cancelado",
        "Logged out": "Sessão expirada, por favor reconecte",
        "Not authorized": "Você não tem permissão para acessar este recurso",
        "Not found": "Página não encontrada",
        "Server error": "Erro do servidor",
        "Unprocessable entity": "Erro de validação",
        "Unsupported media type": "Tipo de mídia não suportado",
      },

    // Input de arquivo
    input: {
      file: {
        upload_single: "Arraste um arquivo para fazer upload ou clique para selecioná-lo",
        upload_several: "Arraste arquivos para fazer upload ou clique para selecioná-los",
      },
    },
    
    // Ações
    action: {
      add: "Adicionar",
      add_filter: "Adicionar filtro",
      back: "Voltar",
      bulk_actions: "Ações em lote",
      bulk_actions_with_count: "Ações em lote",
      bulk_actions_with_count_one: "1 item selecionado",
      bulk_actions_with_count_other: "%{smart_count} itens selecionados",
      // Chave específica para o componente BulkActionsToolbar
      "ra.action.bulk_actions": "%{smart_count} itens selecionados",
      cancel: "Cancelar",
      clear_array_input: "Limpar lista",
      clear_input_value: "Limpar",
      clone: "Clonar",
      close: "Fechar",
      confirm: "Confirmar",
      create: "Criar",
      delete: "Excluir",
      edit: "Editar",
      export: "Exportar",
      filter: "Filtrar",
      import: "Importar",
      list: "Listar",
      refresh: "Atualizar",
      remove_filter: "Remover filtro",
      save: "Salvar",
      search: "Pesquisar",
      select_all: "Selecionar todos",
      select_row: "Selecionar linha",
      show: "Visualizar",
      sort: "Ordenar",
      undo: "Desfazer",
      unselect: "Desmarcar",
      expand: "Expandir",
      close_menu: "Fechar menu",
      open_menu: "Abrir menu",
    },

    // Ordenação
    sort: {
      sort_by: "Classificar por %{field} em ordem %{order}",
      ASC: "crescente",
      DESC: "decrescente",
    },



    // Mensagens de notificação
    message: {
      about: "Sobre",
      are_you_sure: "Tem certeza?",
      auth_error: "Erro de autenticação",
      bulk_delete_content: "Tem certeza que deseja excluir %{name}?",
      bulk_delete_title: "Excluir %{name}",
      clear_input: "Limpar",
      confirm: "Confirmar",
      delete_content: "Tem certeza que deseja excluir este item?",
      delete_title: "Excluir %{name}",
      details: "Detalhes",
      error: "Ocorreu um erro",
      invalid_form: "Formulário inválido",
      loading: "Carregando...",
      no: "Não",
      not_found: "Página não encontrada",
      unsaved_changes: "Alterações não salvas",
      yes: "Sim",
    },

    // Campos e validações
    validation: {
      required: "Campo obrigatório",
      minLength: "Deve ter pelo menos %{min} caracteres",
      maxLength: "Deve ter no máximo %{max} caracteres",
      minValue: "Deve ser pelo menos %{min}",
      maxValue: "Deve ser no máximo %{max}",
      number: "Deve ser um número",
      email: "Deve ser um email válido",
      oneOf: "Deve ser uma das opções disponíveis",
      regex: "Formato inválido",
    },

    // Páginas
    page: {
      dashboard: "Painel",
      empty: "Página vazia",
      error: "Algo deu errado",
      invite: "Convidar",
      loading: "Carregando...",
      not_found: "Página não encontrada",
    },


    // Recursos
    resources: {
      contacts: {
        name: "Contato",
        fields: {
          first_name: "Primeiro nome",
          last_name: "Sobrenome",
          email: "Email",
          phone: "Telefone",
          company: "Empresa",
          position: "Cargo",
          last_seen: "Último visto",
        },
      },
      companies: {
        name: "Empresa",
        fields: {
          name: "Nome",
          sector: "Setor",
          address: "Endereço",
          city: "Cidade",
          state: "Estado",
        },
      },
      deals: {
        name: "Negócio",
        fields: {
          name: "Nome",
          value: "Valor",
          stage: "Estágio",
          category: "Categoria",
          description: "Descrição",
        },
      },
    },
  },

  // Mensagens específicas do SimpleCRM
  simplecrm: {
    // Dashboard
    dashboard: {
      title: "Painel de Controle",
      stats: {
        total_contacts: "Total de Contatos",
        total_companies: "Total de Empresas", 
        total_deals: "Total de Negócios",
        total_value: "Valor Total",
      },
      
      // Componentes do Dashboard
      hot_contacts: {
        title: "Contatos Quentes",
        create_tooltip: "Criar contato",
        empty_message: "Contatos com status 'quente' aparecerão aqui.",
        empty_help: "Altere o status de um contato adicionando uma nota e clicando em 'mostrar opções'.",
      },
      
      deals_chart: {
        title: "Receita de Negócios Futuros",
        won: "Ganhos",
        lost: "Perdidos",
        pending: "Pendentes",
      },
      
      tasks: {
        title: "Tarefas Próximas",
        overdue: "Atrasadas",
        today: "Hoje",
        tomorrow: "Amanhã",
        this_week: "Esta semana",
        later: "Mais tarde",
        empty_message: "Tarefas adicionadas aos seus contatos aparecerão aqui.",
      },
      
      stepper: {
        title: "O que vem a seguir?",
        progress: "concluído",
        install_title: "Instalar SimpleCRM",
        add_contact_title: "Adicionar seu primeiro contato",
        add_note_title: "Adicionar sua primeira nota",
        add_note_help: "Vá para uma página de contato e adicione uma nota",
        add_note_button: "Adicionar nota",
      },
      
      welcome: {
        title: "Seu Kit Inicial de CRM",
        description1: "SimpleCRM é um template projetado para ajudá-lo a construir rapidamente seu próprio CRM.",
        description2: "Esta demonstração roda em uma API simulada, então você pode explorar e modificar os dados. Ela reinicia ao recarregar. A versão completa usa Supabase para o backend.",
        description3: "Desenvolvido com shadcn-admin-kit, SimpleCRM é totalmente open-source. Você pode encontrar o código em marmelab/simple-crm.",
      },
      
      // Menu do usuário
      user_menu: {
        my_info: "Minhas informações",
        users: "Usuários",
        logout: "Sair",
      },
      
      // Atividade
      activity: {
        title: "Atividade Recente",
        added_company: "adicionou empresa",
        added_contact: "adicionou contato",
        added_deal: "adicionou negócio",
        added_note_about_deal: "adicionou uma nota sobre o negócio",
        added_note_about: "adicionou uma nota sobre",
        sales_id: "ID Vendas",
        to_company: "para empresa",
        today_at: "hoje às",
        load_more: "Carregar mais atividades",
      },
    },

    // Navegação
    navigation: {
      dashboard: "Painel",
      contacts: "Contatos",
      companies: "Empresas",
      deals: "Negócios",
    },

    // Formulários
    forms: {
      new_contact: "Novo Contato",
      edit_contact: "Editar Contato",
      new_company: "Nova Empresa",
      edit_company: "Editar Empresa",
      new_deal: "Novo Negócio",
      edit_deal: "Editar Negócio",
    },

    // Módulo de Contatos
    contacts: {
      // Lista de contatos
      no_contacts_found: "Nenhum contato encontrado",
      empty_list_message: "Parece que sua lista de contatos está vazia.",
      new_contact: "Novo Contato",
      at: "em",
      task: "tarefa",
      tasks: "tarefas",
      last_activity: "última atividade",

      // Campos do formulário
      identity: "Identidade",
      first_name: "Nome",
      last_name: "Sobrenome",
      email: "Email",
      position: "Cargo",
      title: "Cargo",
      company: "Empresa",
      personal_info: "Informações Pessoais",
      email_addresses: "Endereços de Email",
      email_placeholder: "Email",
      phone_numbers: "Números de Telefone",
      phone_placeholder: "Número de telefone",
      linkedin_url: "URL do LinkedIn",
      misc: "Diversos",
      background_info: "Informações de fundo (bio, como vocês se conheceram, etc)",
      has_newsletter: "Recebe newsletter",
      account_manager: "Gerente de Conta",

      // Filtros
      search_placeholder: "Pesquisar nome, empresa...",
      filters: {
        last_activity: "Última Atividade",
        today: "Hoje",
        this_week: "Esta semana",
        before_this_week: "Antes desta semana",
        before_this_month: "Antes deste mês",
        before_last_month: "Antes do mês passado",
        status: "Status",
        tags: "Tags",
        tasks: "Tarefas",
        with_pending_tasks: "Com tarefas pendentes",
        account_manager: "Gerente de Conta",
        me: "Eu",
      },

        // Importação
        import: {
          running: "A importação está em execução, não feche esta aba.",
          imported: "Importados {count} de {total} contatos, com {errors} erros.",
          estimated_time: "Tempo estimado restante: {time}.",
          stop: "Parar importação",
          error: "Falha ao importar este arquivo, certifique-se de que forneceu um arquivo CSV válido.",
          complete: "Importação de contatos concluída. Importados {count} contatos, com {errors} erros",
          sample_description: "Aqui está um arquivo CSV de exemplo que você pode usar como modelo",
          download_sample: "Baixar exemplo CSV",
          csv_file: "Arquivo CSV",
        },
        // Detalhes do contato
        edit_contact: "Editar Contato",
        show_contact: "Ver Contato",
        subscribed_newsletter: "Inscrito na newsletter",
        added_on: "Adicionado em",
        last_activity_on: "Última atividade em",
        followed_by: "Seguido por",
        linkedin: "LinkedIn",
        you: "Você",
        add_tag: "Adicionar tag",
        create_new_tag: "Criar nova tag",
    },
    // Notas
    notes: {
      add_note: "Adicionar uma nota",
      show_options: "Mostrar opções",
      attach_files_details: "(anexar arquivos ou alterar detalhes)",
      date: "Data",
      note_added: "Nota adicionada",
      add_this_note: "Adicionar esta nota",
      added_note: "adicionou uma nota",
      edit_note: "Editar nota",
      delete_note: "Excluir nota",
      update_note: "Atualizar nota",
      note_deleted: "Nota excluída",
      attachments: "Anexos",
    },
    // Tarefas
    tasks: {
      task_added: "Tarefa adicionada",
      create_task: "Criar tarefa",
      add_task: "Adicionar tarefa",
      create_task_for: "Criar uma nova tarefa para ",
      create_new_task: "Criar uma nova tarefa",
      description: "Descrição",
      contact: "Contato",
      task_deleted_successfully: "Tarefa excluída com sucesso",
      postpone_tomorrow: "Adiar para amanhã",
      postpone_next_week: "Adiar para próxima semana",
      edit_task: "Editar tarefa",
      task_updated: "Tarefa atualizada",
      task_deleted: "Tarefa excluída",
      due_date: "Data de vencimento",
      type: "Tipo",
    },
    // Empresas
    companies: {
      no_companies_found: "Nenhuma empresa encontrada",
      empty_list: "Parece que sua lista de empresas está vazia.",
      create_company: "Criar Empresa",
      size: "Tamanho",
      sector: "Setor",
      account_manager: "Gerente de Conta",
      me: "Eu",
      company_name: "Nome da empresa",
      contact: "Contato",
      context: "Contexto",
      address: "Endereço",
      additional_information: "Informações adicionais",
      edit_company: "Editar Empresa",
      show_company: "Ver Empresa",
      company_info: "Informações da Empresa",
      main_address: "Endereço Principal",
      additional_info: "Informações Adicionais",
      revenue: "Receita",
      tax_identifier: "Identificador Fiscal",
      followed_by: "Seguido por",
      added_on: "Adicionado em",
      // Campos para ordenação
      name: "Nome",
      created_at: "Data de criação",
      nb_contacts: "Número de contatos",
      // Negócios
      deal: "negócio",
      deals: "negócios",
      // Abas da página de detalhes
      activity: "Atividade",
      one_contact: "1 Contato",
      multiple_contacts: "%{count} Contatos",
      no_contacts: "Nenhum Contato",
      one_deal: "1 negócio",
      multiple_deals: "%{count} negócios",
      // Campos do formulário
      name_field: "Nome",
      website: "Website",
      linkedin_url: "URL do LinkedIn",
      phone_number: "Número de telefone",
      address_field: "Endereço",
      city: "Cidade",
      zipcode: "CEP",
      state: "Estado",
      country: "País",
      description: "Descrição",
      context_links: "Links de contexto",
    },
    // Módulo Deals (Negócios)
    deals: {
      new_deal: "Novo Negócio",
      only_companies_i_manage: "Apenas empresas que gerencio",
      company: "Empresa",
      category: "Categoria",
      // Estágios de negócios
      opportunity: "Oportunidade",
      proposal_sent: "Proposta Enviada",
      in_negotiation: "Em Negociação",
      won: "Ganho",
      lost: "Perdido",
      delayed: "Atrasado",
      // Categorias de negócios
      other: "Outro",
      copywriting: "Redação",
      print_project: "Projeto Gráfico",
      ui_design: "Design de Interface",
      website_design: "Design de Website",
      // Mensagens
      no_deals_found: "Nenhum negócio encontrado",
      empty_list: "Parece que sua lista de negócios está vazia.",
      create_deal: "Criar negócio",
      deal_updated: "Negócio atualizado",
      deal_created: "Negócio criado",
      deal_deleted: "Negócio excluído",
      // Campos do formulário
      deal_name: "Nome do negócio",
      amount: "Valor",
      stage: "Estágio",
      contact: "Contato",
      description: "Descrição",
      expected_close_date: "Data de fechamento esperada",
      probability: "Probabilidade",
      // Validações
      amount_required: "O valor é obrigatório",
      deal_name_required: "O nome do negócio é obrigatório",
      stage_required: "O estágio é obrigatório",
      // Mensagens adicionais
      before_creating_deal: "antes de criar um negócio.",
      // Seções do formulário
      linked_to: "Vinculado a",
      misc: "Outros",
      contacts: "Contatos",
    },
    // Miscelânea
    misc: {
      change: "Alterar/Trocar",
      add_image: "Foto/Logo",
    },
  },
};
